import React, { useState } from 'react'
import {
  Card,
  Button,
  Input,
  Divider,
  Row,
  Col,
  Form,
  Spin,
  Select,
  Checkbox,
  Radio,
  Modal,
  message,
  Upload
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { InputGroup } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import CKEditor from 'react-ckeditor-component'
import {
  ArrowLeftOutlined,
  LoadingOutlined,
  PlusOutlined
} from '@ant-design/icons'
import ds from '../../../Services/DataServices'
import {
  loadReceiptTemplatesUpdated,
  loadReceiptTemplatesLoading
} from '../../../appRedux/actions/Setup'
import { useDispatch, useSelector } from 'react-redux'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { OUTLETREGISTER_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { notAllowMsgCheck } from '../../../appRedux/actions'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const confirm = Modal.confirm

const AddReceiptTemplate = ({ match }) => {
  const templateID = match.params.id ? match.params.id : false
  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxTemplatesUpdated = useSelector(
    ({ Setup }) => Setup.isReceiptTemplateUpdated
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [confirmLoading, setConfirmLoading] = useState(false) // change state
  const [descriptionContent, setDescriptionContent] = useState('')
  const [LineItemRadioButton, setLineItemRadioButton] = useState(2)
  const [displayTaxTotals, setDisplayTaxTotals] = useState(false)
  const [displayLoyaltyEarned, setDisplayLoyaltyEarned] = useState(false)
  const [displayCustomerInfo, setDisplayCustomerInfo] = useState(false)
  const [displayLoyaltyBalance, setDisplayLoyaltyBalance] = useState(false)
  const [descriptionFooterContent, setDescriptionFooterContent] = useState('')
  const [displayLoyaltyMessage, setDisplayLoyaltyMessage] = useState(false)
  const [getTemplateName, setTemplateName] = useState('')
  const [getTemplateStyles, setTemplateStyles] = useState([])
  const [getIsDisplayServed, setIsDisplayServed] = useState(false)
  const [getIsDisplayTaxLineItem, setIsDisplayTaxLineItem] = useState(false)
  const [getIsDisplayGiftInfo, setIsDisplayGiftInfo] = useState(false)
  const [getCustomerName, setCustomerName] = useState(false)
  const [getCustomerCompanyName, setCustomerCompanyName] = useState(false)
  const [getCustomerCode, setCustomerCode] = useState(false)
  const [getCustomerEmail, setCustomerEmail] = useState(false)
  const [getCustomerPhone, setCustomerPhone] = useState(false)
  const [getCustomerAddress, setCustomerAddress] = useState(false)
  const [getIsDisplayBarCode, setIsDisplayBarCode] = useState(false)
  const [getPlainDescContent, setPlainDescContent] = useState('')
  const [getPlainFooterContent, setPlainFooterContent] = useState('')
  const [imageUrl, setimageUrl] = useState(false)
  const [loading, setLoading] = useState(false)
  const [getIsImageUpdated, setIsImageUpdated] = useState(false)
  const [getIsImageExist, setIsImageExist] = useState(false)
  const [getImageFile, setImageFile] = React.useState({})
  const [getAllowedConfig, setAllowedConfig] = useState({})
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])

  const [getIsDisplayOutlet, setIsDisplayOutlet] = useState(false)
  const [getIsDisplayRegister, setIsDisplayRegister] = useState(false)
  const [getIsDisplayDateTime, setIsDisplayDateTime] = useState(false)
  const [getIsDisplayOnlyPProduc, setIsDisplayOnlyPProduc] = useState(false)

  const [displayTotal, setDisplayTotal] = useState(false)
  const [displaySubTotal, setDisplaySubTotal] = useState(false)
  const [displayProdPrice, setDisplayProdPrice] = useState(false)
  const [displayPayments, setDisplayPayments] = useState(false)

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(
        PostAppTypes.PAGE_HEADER,
        templateID
          ? 'setup.outletsandregisters.updateReceiptTitle'
          : 'setup.outletsandregisters.createReceiptTitle'
      )
    }

    dispatch(setCommonConfigs(OUTLETREGISTER_SCREEN))
    form.setFieldsValue({
      // TemplateStyle: 1,
      InvoicePrefix: 'Receipt / Tax Invoice',
      SubTotal: 'Subtotal',
      TotalLabel: 'TOTAL',
      ChangeLabel: 'Change',
      PayLabel: 'TO PAY',
      TaxTotal: 'Total Tax',
      LoyaltyEarned: 'LOYALTY EARNED',
      LoyaltyMessage: 'Register your details with us for Loyalty Program:'
    })
    setIsDisplayServed(true)
    setDisplayTaxTotals(true)
    setDisplayLoyaltyEarned(true)
    setIsDisplayBarCode(true)
    setDisplayLoyaltyMessage(true)
    // getStyleService()
    if (templateID) {
      let body = {
        TemplateID: templateID
      }
      getTemplateService(body)
    }
  }, [])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  async function getStyleService () {
    await ds
      .getTemplateStyleService('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (!templateID) {
          setConfirmLoading(false)
        }
        if (res && res.length > 0) {
          setTemplateStyles(res)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong')
        setConfirmLoading(false)
      })
  }
 
  async function getTemplateService (body) {
    //
    await ds
      .getReceiptTemplatesService(body)
      .then(res => {
        setConfirmLoading(false)
        if (res && res.length > 0) {
          let data = res[0]
          form.setFieldsValue({
            TemplateName: data.templateName,
            // TemplateStyle: data.templateStyleID,
            InvoicePrefix: data.invoiceNoPrefix
              ? data.invoiceNoPrefix
              : 'Receipt / Tax Invoice',
            Served: data.isDisplayServedBy ? data.servedByLabel : '',
            SubTotal: data.subTotalLabel ? data.subTotalLabel : 'Subtotal',
            TotalLabel: data.totalLabel ? data.totalLabel : 'TOTAL',
            ChangeLabel: data.changeLabel ? data.changeLabel : 'Change',
            LoyaltyBalance: data.showCustomerBalances
              ? data.loyaltyBalanceLabel
              : '',
            PayLabel: data.toPayLabel ? data.toPayLabel : 'TO PAY',
            TaxTotal:
              data.showTaxTotals && data.taxTotalLabel
                ? data.taxTotalLabel
                : 'Total Tax',
            LoyaltyEarned:
              data.showLoyaltyEarned && data.loyaltyEarnedLabel
                ? data.loyaltyEarnedLabel
                : 'LOYALTY EARNED',
            LoyaltyMessage: data.loyaltyMessage
              ? data.loyaltyMessage
              : 'Register your details with us for Loyalty Program:'
          })
          setimageUrl(data.headImageURL)
          setTemplateName(data.templateName)
          setIsImageExist(data.headImageURL != '' ? true : false)
          setDescriptionContent(data.headInfoHtml)
          setPlainDescContent(data.headInfoPlain)
          setIsDisplayServed(data.isDisplayServedBy)
          setLineItemRadioButton(
            data.showProductNameAndSKU
              ? 1
              : data.showProductName
              ? 2
              : data.showSKU
              ? 3
              : 2
          )
          setIsDisplayTaxLineItem(data.showTaxPerLineItem)
          setDisplayTaxTotals(data.showTaxTotals)
          setDisplayLoyaltyEarned(data.showLoyaltyEarned)
          setIsDisplayGiftInfo(data.showGiftCardInfo)
          setDisplayCustomerInfo(data.showCustomerDetails)
          setCustomerName(
            data.showCustomerDetails && data.showCustomerName ? true : false
          )
          setCustomerPhone(
            data.showCustomerDetails && data.showCustomerPhone ? true : false
          )
          setCustomerAddress(
            data.showCustomerDetails && data.showCustomerAddress ? true : false
          )
          setCustomerCode(
            data.showCustomerDetails && data.showCustomerCode ? true : false
          )
          setCustomerCompanyName(
            data.showCustomerDetails && data.showCustomerCompany ? true : false
          )
          setCustomerEmail(
            data.showCustomerDetails && data.showCustomerEmail ? true : false
          )
          setDisplayLoyaltyBalance(
            data.showCustomerDetails && data.showCustomerBalances ? true : false
          )
          setDescriptionFooterContent(data.footerHtml)
          setPlainFooterContent(data.footerPlain)
          setIsDisplayBarCode(data.showBarCode)
          setDisplayLoyaltyMessage(data.showLoyaltyMessage)

          setIsDisplayOutlet(data.showOutlet)
          setIsDisplayRegister(data.showRegister)
          setIsDisplayDateTime(data.showDatetime)
          setIsDisplayOnlyPProduc(data.showPrinterProds)

          setDisplayTotal(data.showTotal)
          setDisplaySubTotal(data.showSubTotal)
          setDisplayProdPrice(data.showProdPrice)
          setDisplayPayments(data.showPayments)
        }
      })
      .catch(error => {
        message.error('Something went wrong')
        setConfirmLoading(false)
      })
  }

  async function postTempService (body, methodType) {
    await ds
      .postReceiptTemplatesService(body, methodType)
      .then(res => {
        if (res == 'Saved') {
          setConfirmLoading(false)
          dispatch(loadReceiptTemplatesUpdated(!getReduxTemplatesUpdated))
          message.success('Template Updated Successfully')
          redirectToListing()
          // setTimeout(() => {
          //   redirectToListing()
          // }, 2000)
        } else if (res == 'Deleted') {
          setConfirmLoading(false)
          dispatch(loadReceiptTemplatesUpdated(!getReduxTemplatesUpdated))
          message.success('Template Deleted Successfully')
          redirectToListing()
          // setTimeout(() => {
          //   redirectToListing()
          // }, 2000)
        } else if (res.includes('Created')) {
          setConfirmLoading(false)
          dispatch(loadReceiptTemplatesUpdated(!getReduxTemplatesUpdated))
          message.success('Template Created Successfully')
          redirectToListing()
          // setTimeout(() => {
          //   redirectToListing()
          // }, 2000)
        } else if (res.includes('default')) {
          setConfirmLoading(false)
          message.info(
            'Template is set to default, set another as default then delete',
            4000
          )
        } else {
          setConfirmLoading(false)
          dispatch(loadReceiptTemplatesLoading(false))
          message.warn('Server down, Try Again Later...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
        dispatch(loadReceiptTemplatesLoading(false))

        message.error('Error Occured')
      })
  }

  const OnChangeDescription = evt => {
    let htmlString = evt.editor.getData()
    let strippedString = htmlString.replace(/(<([^>]+)>)/gi, '')
    setDescriptionContent(htmlString)
    setPlainDescContent(strippedString)
  }

  const OnChangeLineItemRadioButton = e => {
    setLineItemRadioButton(e.target.value)
  }

  const OnChangeFooterDescription = evt => {
    let htmlString = evt.editor.getData()
    let strippedString = htmlString.replace(/(<([^>]+)>)/gi, '')
    setDescriptionFooterContent(htmlString)
    setPlainFooterContent(strippedString)
  }

  const redirectToListing = () => {
    history.push('/Dashboard/Setup/OutletsAndRegisters/listing')
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }

  const onFinishFailed = errorInfo => {
    message.error('Please Try Again...')
  }

  const onFinish = values => {
    // ;
    try {
      const methType = templateID ? BEHAVIOUR_TYPE.UPDATE : BEHAVIOUR_TYPE.POST
      let behaviorMod = templateID ? 3 : 1
      const formData = new FormData()
      formData.append('Behavior', behaviorMod)
      formData.append(
        'IsImageUpdated',
        getIsImageUpdated && templateID && getIsImageExist ? true : false
      )
      formData.append('HeadImage', getImageFile)
      formData.append('TemplateID', templateID ? templateID : '')
      formData.append('HeadInfoHtml', descriptionContent)
      formData.append('HeadInfoPlain', getPlainDescContent)
      formData.append('IsDisplayServedBy', getIsDisplayServed)
      formData.append('SubTotalLabel', values.SubTotal ? values.SubTotal : '')
      formData.append('TotalLabel', values.TotalLabel ? values.TotalLabel : '')
      formData.append('ToPayLabel', values.PayLabel ? values.PayLabel : '')
      formData.append('FooterPlain', getPlainFooterContent)
      formData.append('FooterHtml', descriptionFooterContent)
      formData.append('ShowSKU', LineItemRadioButton == 3 ? true : false)
      formData.append('ShowTaxPerLineItem', getIsDisplayTaxLineItem)
      formData.append('ShowLoyaltyEarned', displayLoyaltyEarned)
      formData.append('ShowGiftCardInfo', getIsDisplayGiftInfo)
      formData.append('ShowCustomerDetails', displayCustomerInfo)
      formData.append('ShowTaxTotals', displayTaxTotals)
      formData.append('ShowBarCode', getIsDisplayBarCode)
      formData.append(
        'ServedByLabel',
        getIsDisplayServed && values.Served ? values.Served : ''
      )
      formData.append(
        'ShowProductName',
        LineItemRadioButton == 2 ? true : false
      )
      formData.append(
        'ShowCustomerCode',
        displayCustomerInfo && getCustomerCode
      )
      formData.append(
        'ShowCustomerName',
        displayCustomerInfo && getCustomerName
      )
      formData.append('ShowLoyaltyMessage', displayLoyaltyMessage)
      formData.append(
        'InvoiceNoPrefix',
        values.InvoicePrefix ? values.InvoicePrefix : ''
      )
      formData.append(
        'ShowProductNameAndSKU',
        LineItemRadioButton == 1 ? true : false
      )
      formData.append(
        'TemplateName',
        values.TemplateName ? values.TemplateName : ''
      )
      formData.append(
        'TemplateStyleID',
        values.TemplateStyle ? values.TemplateStyle : 0
      )
      formData.append(
        'ChangeLabel',
        values.ChangeLabel ? values.ChangeLabel : ''
      )
      formData.append(
        'ShowCustomerBalances',
        displayCustomerInfo && displayLoyaltyBalance
      )
      formData.append(
        'ShowCustomerAddress',
        displayCustomerInfo && getCustomerAddress
      )
      formData.append(
        'ShowCustomerPhone',
        displayCustomerInfo && getCustomerPhone
      )
      formData.append(
        'ShowCustomerEmail',
        displayCustomerInfo && getCustomerEmail
      )
      formData.append(
        'ShowCustomerCompany',
        displayCustomerInfo && getCustomerCompanyName
      )
      formData.append(
        'LoyaltyBalanceLabel',
        displayCustomerInfo && displayLoyaltyBalance && values.LoyaltyBalance
          ? values.LoyaltyBalance
          : ''
      )
      formData.append(
        'TaxTotalLabel',
        displayTaxTotals && values.TaxTotal ? values.TaxTotal : ''
      )
      formData.append(
        'LoyaltyEarnedLabel',
        displayLoyaltyEarned && values.LoyaltyEarned ? values.LoyaltyEarned : ''
      )
      formData.append(
        'LoyaltyMessage',
        displayLoyaltyMessage && values.LoyaltyMessage
          ? values.LoyaltyMessage
          : ''
      )

      formData.append('ShowOutlet', getIsDisplayOutlet)
      formData.append('ShowRegister', getIsDisplayRegister)
      formData.append('ShowDatetime', getIsDisplayDateTime)
      formData.append('ShowPrinterProds', getIsDisplayOnlyPProduc)

      formData.append('ShowTotal', displayTotal)
      formData.append('ShowSubTotal', displaySubTotal)
      formData.append('ShowProdPrice', displayProdPrice)
      formData.append('ShowPayments', displayPayments)

      setConfirmLoading(true)
      postTempService(formData, methType)
    } catch (err) {
      message.error('Error Occured')
    }
  }

  function beforeUpload (file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    // }
    if (isJpgOrPng) {
      var reader = new FileReader()
      //Read the contents of Image File.
      reader.readAsDataURL(file.originFileObj)
      reader.onload = function (e) {
        //Initiate the JavaScript Image object.
        var image = new Image()

        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result

        //Validate the File Height and Width.
        image.onload = function () {
          var height = this.height
          var width = this.width
          if (height > 280 || width > 280) {
            message.warn('Height and Width must not exceed 280px.')
            return false
          }
          return true
        }
      }
    } else {
      message.error('You can only upload JPG/PNG file!')
      return false
    }
  }

  const handleUpload = info => {
    setLoading(true)
    if (templateID && getIsImageExist) {
      setIsImageUpdated(true)
    }
    let type = info.file.type
    const isJpgOrPng = type === 'image/jpeg' // || type === 'image/png'
    if (isJpgOrPng) {
      var reader = new FileReader()
      //Read the contents of Image File.
      reader.readAsDataURL(info.file.originFileObj)
      reader.onload = function (e) {
        //Initiate the JavaScript Image object.
        var image = new Image()

        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result

        //Validate the File Height and Width.
        image.onload = function () {
          var height = this.height
          var width = this.width
          if (height < 281 || width < 281) {
            setImageFile(info.file.originFileObj)
            let fileReader = new FileReader()
            fileReader.readAsDataURL(info.file.originFileObj)
            setTimeout(() => {
              setimageUrl(fileReader.result)
              setLoading(false)
            }, 2000)
          } else {
            message.warn('Height and Width must not greater than 280px.', 4)
            setLoading(false)
            setimageUrl('')
          }
        }
      }
    } else {
      message.error('You can only upload JPG file!')
      setLoading(false)
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>
        <IntlMessages id='sidebar.dataEntry.upload' />
      </div>
    </div>
  )

  function onDeleteConfirm () {
    let body = new FormData()
    body.append('TemplateID', templateID)
    body.append('Behavior', 2)
    setConfirmLoading(true)
    dispatch(loadReceiptTemplatesLoading(true))
    postTempService(body, BEHAVIOUR_TYPE.DELETE)
  }

  function showDeleteConfirm () {
    confirm({
      title: 'Are you sure to delete this Template?',
      content: `"${getTemplateName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk () {
        onDeleteConfirm()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const config = {
    // // // NOTE: INFO => (https://ckeditor.com/latest/samples/old/toolbar/toolbar.html)
    // // // => (https://ckeditor.com/latest/samples/toolbarconfigurator/#basic)
    toolbar: [
      {
        name: 'document',
        groups: ['mode', 'document', 'doctools'],
        items: [
          'Source',
          '-',
          'Save',
          'NewPage',
          'ExportPdf',
          'Preview',
          'Print',
          '-',
          'Templates'
        ]
      },
      {
        name: 'align',
        items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
      },
      {
        name: 'clipboard',
        groups: ['clipboard', 'undo'],
        items: [
          'Cut',
          'Copy',
          'Paste',
          'PasteText',
          'PasteFromWord',
          '-',
          'Undo',
          'Redo'
        ]
      },
      {
        name: 'editing',
        groups: ['find', 'selection'],
        items: ['Find', 'Replace', '-', 'SelectAll']
      },
      {
        name: 'forms',
        items: ['TextField', 'Textarea', 'Select']
      },
      '/',
      {
        name: 'basicstyles',
        groups: ['basicstyles', 'cleanup'],
        items: ['Bold', 'Italic', 'Underline']
      },
      {
        name: 'paragraph',
        groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
        items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight']
      },
      '/',
      { name: 'styles', items: ['FontSize', 'Font', 'Format'] },
      { name: 'about', items: ['About'] }
    ],
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'forms' },
      '/',
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      {
        name: 'paragraph',
        groups: ['list', 'indent', 'blocks', 'align', 'bidi']
      },
      { name: 'links' },
      { name: 'insert' },
      '/',
      { name: 'styles' },
      { name: 'colors' },
      { name: 'tools' },
      { name: 'others' },
      { name: 'about' }
    ]
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper CreateReceiptTemplate-pg'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={confirmLoading}
        size='large'
      >
        <>

          {checkIsWeb().exist && (
               <div className="back-arrow-h1">
                <h1 className="d-flex align-items-center">
                  <ArrowLeftOutlined
                    className='dk-vertical-align'
                    onClick={redirectToListing}
                  />
                  <span className="mx-2">
                  {' '}
                  {templateID ? (
                    <IntlMessages id='setup.outletsandregisters.updateReceiptTitle' />
                  ) : (
                    <IntlMessages id='setup.outletsandregisters.createReceiptTitle' />
                  )}
                  </span>
                </h1>
              </div>
          )}

<Row className="ant-row dk-row-bg-color m-0 Sec-heading-bg">
<Col lg={12} md={10} sm={24} xs={24}>
<p className="title vd-hero-intro custom-font-color-black m-0">
                <IntlMessages id='setup.outletsandregisters.createDescription' />
              </p>
            </Col>
            <Col lg={12} md={14} sm={24} xs={24}>
            <div className="pg-header-btn mt-10-md">
                {templateID && (
                  <Button
                    className='dk-btn-cancel'
                    type='primary'
                    // style={{ fontSize: "large" }}
                    onClick={showDeleteConfirm}
                    size='large'
                    disabled={getIsDisableDelete}
                  >
                    <IntlMessages id='setup.outletsandregisters.tempcol3' />
                  </Button>
                )}
                <Button
                  className='dk-btn-cancel'
                  type='primary'
                  onClick={redirectToListing}
                  size='large'
                >
                  <IntlMessages id='setup.addloyalty.cancelBtn' />
                </Button>
                <Button
                  className='dk-btn-add'
                  type='primary'
                  htmlType='submit'
                  form='TemplateForm'
                  size='large'
                  disabled={
                    templateID ? getIsDisableUpdate : getIsDisableCreate
                  }
                >
                  {templateID ? (
                    <IntlMessages id='setup.outletsandregisters.templateStyleLabelup' />
                  ) : (
                    <IntlMessages id='setup.outletsandregisters.templateStyleLabeladd' />
                  )}
                </Button>
              </div>
            </Col>
          </Row>

          <div className='custom-mg-top-25'>


            <Row className='General-div'>

              <Col lg={6} md={24} sm={24} xs={24}>
              <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.generalHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.generalDescription' />
                </p>
              </Col>

              <Col lg={18} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  className='form-inner-pad-0'
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                 
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                        name='TemplateName'
                        label={
                          
                            <IntlMessages id='setup.outletsandregisters.templateLabel' />
                          
                        }
                      >
                        <Input  placeholder="Enter template name" maxLength={100}/>
                      </Form.Item>
                    
                </Form>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <Row>
            <Col lg={6} md={24} sm={24} xs={24}>
                <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.headerHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.headerDescription' />
                </p>
              </Col>
              <Col lg={18} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  className='form-inner-pad-0'
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                  <InputGroup size='large' className='gx-mb-3'>
                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                      name='Logo'
                      label={
                        <h3 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust mb-0">
                          <IntlMessages id='setup.outletsandregisters.logoLabel' />
                          </h3>
                      }
                    >
                      {/* <Input type="file" /> */}
                      <div className='custom-promoadd-xcard'>
                        <Upload
                          name='avatar'
                          listType='picture-card'
                          className='avatar-uploader'
                          showUploadList={false}
                          // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                          // beforeUpload={beforeUpload}
                          onChange={handleUpload}
                        >
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt='avatar'
                            />
                          ) : (
                            uploadButton
                          )}
                        </Upload>
                        {imageUrl && (
                          <p className='font-size-smaller'>
                            <IntlMessages id='setup.userroles.changeimg' />
                          </p>
                        )}
                      </div>
                      <p>
                        <IntlMessages id='setup.outletsandregisters.uploadimgprop' />
                      </p>
                    </Form.Item>
                  </InputGroup>

                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                    name='HeaderInformation'
                    label={
                      
                        <IntlMessages id='setup.outletsandregisters.headerInfoLabel' />
                      
                    }
                  >
                    <CKEditor
                      activeClass='p10'
                      content={descriptionContent}
                      events={{
                        change: OnChangeDescription
                      }}
                      config={config}
                    />
                    <p>
                      <IntlMessages id='setup.outletsandregisters.limitcontent' />
                    </p>
                  </Form.Item>

                  <InputGroup size='large' className='gx-mb-3'>
                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right custome-form-col-100'
                      name='InvoicePrefix'
                      label={
                        
                          <IntlMessages id='setup.outletsandregisters.invoiceLabel' />
                        
                      }
                    >
                      <Input   maxLength={100}/>
                    </Form.Item>
                  </InputGroup>

                  <Form.Item>
                    <Checkbox
                      checked={getIsDisplayServed}
                      onChange={() => setIsDisplayServed(!getIsDisplayServed)}
                    >
                      <p>
                        <IntlMessages id='setup.outletsandregisters.displayLabel' />
                      </p>
                    </Checkbox>
                  </Form.Item>

                  {getIsDisplayServed && (
                    <InputGroup size='large' className='gx-mb-3'>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right custome-form-col-100'
                        name='Served'
                        label={
                        
                            <IntlMessages id='setup.outletsandregisters.servedLabel' />
                          
                        }
                      >
                        <Input  maxLength={100}/>
                      </Form.Item>
                    </InputGroup>
                  )}
                </Form>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <Row className='LineItems-div'>

            <Col lg={6} md={24} sm={24} xs={24}>
              <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.lineItemsHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.lineItemsDescription' />
                </p>
              </Col>

              <Col lg={18} md={24} sm={24} xs={24}>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  className='form-inner-pad-0'
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                  <Radio.Group
                    style={{ display: 'inline-grid' }}
                    size='large'
                    name='radiogroupline'
                    onChange={OnChangeLineItemRadioButton}
                    value={LineItemRadioButton}
                  >
                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                      name='HeaderInformation'
                      label={
                        
                          <IntlMessages id='setup.outletsandregisters.headerInfoLabel' />
                        
                      }
                    >
                      <Radio value={1}>
                        <IntlMessages id='setup.outletsandregisters.lineRadioLabel1' />
                      </Radio>
                      <Radio value={2}>
                        <IntlMessages id='setup.outletsandregisters.lineRadioLabel2' />
                      </Radio>
                      <Radio value={3}>
                        <IntlMessages id='setup.outletsandregisters.lineRadioLabel3' />
                      </Radio>
                    </Form.Item>
                  </Radio.Group>
                  {/* <Form.Item>
                    <Checkbox
                      style={{ fontSize: "15px", marginLeft: "15px" }}
                      checked={getIsDisplayTaxLineItem}
                      onChange={() =>
                        setIsDisplayTaxLineItem(!getIsDisplayTaxLineItem)
                      }
                    >
                      <p style={{ fontSize: "15px" }}>
                        <IntlMessages id="setup.outletsandregisters.lineCheckboxLabel" />
                      </p>
                    </Checkbox>
                  </Form.Item> */}
                </Form>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <Row className='Totals-div'>

            <Col lg={6} md={24} sm={24} xs={24}>
                <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.totalsHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.totalsDescription' />
                </p>
              </Col>

              <Col lg={18} md={24} sm={24} xs={24} className='p-0'>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  className=''
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                  <InputGroup size='large' className='gx-mb-3'>
                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right custome-form-col-50'
                      name='SubTotal'
                      label={
                      
                          <IntlMessages id='setup.outletsandregisters.subTotalLabel' />
                       
                      }
                    >
                      <Input   maxLength={100}/>
                    </Form.Item>

                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right custome-form-col-50'
                      name='TotalLabel'
                      label={
                        
                          <IntlMessages id='setup.outletsandregisters.totalLabel' />
                      
                      }
                    >
                      <Input  maxLength={100} />
                    </Form.Item>

                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right custome-form-col-50'
                      name='ChangeLabel'
                      label={
                       
                          <IntlMessages id='setup.outletsandregisters.changeLabel' />
                       
                      }
                    >
                      <Input  maxLength={100} />
                    </Form.Item>

                    <Form.Item
                      className='ant-form-item-label-custom ant-form-margin-right custome-form-col-50'
                      name='PayLabel'
                      label={
                        
                          <IntlMessages id='setup.outletsandregisters.toPayLabel' />
                       
                      }
                    >
                      <Input  maxLength={100} />
                    </Form.Item>
                  </InputGroup>

                  <Form.Item>
                    <Checkbox
                      onChange={() => setDisplayTaxTotals(!displayTaxTotals)}
                      checked={displayTaxTotals}
                    >
                      <p>
                        <IntlMessages id='setup.outletsandregisters.displayTaxLabel' />
                      </p>
                    </Checkbox>
                  </Form.Item>

                  {displayTaxTotals && (
                    <InputGroup size='large' className='gx-mb-3'>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right custome-form-col-100'
                        name='TaxTotal'
                        label={
                          <strong>
                            <IntlMessages id='setup.outletsandregisters.displayTaxLabel.showLabel' />
                          </strong>
                        }
                      >
                        <Input   maxLength={100}/>
                      </Form.Item>
                    </InputGroup>
                  )}

                  <Form.Item>
                    <Checkbox
                      onChange={() =>
                        setDisplayLoyaltyEarned(!displayLoyaltyEarned)
                      }
                      checked={displayLoyaltyEarned}
                    >
                      <p>
                        <IntlMessages id='setup.outletsandregisters.displayLoyaltyLabel' />
                      </p>
                    </Checkbox>
                  </Form.Item>

                  {displayLoyaltyEarned && (
                    <InputGroup size='large' className='gx-mb-3'>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right custome-form-col-100'
                        name='LoyaltyEarned'
                        label={
                          <strong>
                            <IntlMessages id='setup.outletsandregisters.displayLoyaltyLabel' />
                          </strong>
                        }
                      >
                        <Input   maxLength={100} />
                      </Form.Item>
                    </InputGroup>
                  )}

                  <Form.Item>
                    <Checkbox
                      checked={getIsDisplayGiftInfo}
                      onChange={() =>
                        setIsDisplayGiftInfo(!getIsDisplayGiftInfo)
                      }
                    >
                      <p className='mb-0'>
                        <IntlMessages id='setup.outletsandregisters.displayGiftInfoLabel' />
                      </p>
                    </Checkbox>
                    <p className='font-size-smaller'>
                      <IntlMessages id='setup.outletsandregisters.displayGiftDescLabel' />
                    </p>
                  </Form.Item>

                  <Form.Item>
                    <Checkbox
                      onChange={() => setDisplayTotal(!displayTotal)}
                      checked={displayTotal}
                    >
                      <p>Display Total Price</p>
                    </Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <Checkbox
                      onChange={() => setDisplaySubTotal(!displaySubTotal)}
                      checked={displaySubTotal}
                    >
                      <p>Display Sub Total Price</p>
                    </Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <Checkbox
                      onChange={() => setDisplayProdPrice(!displayProdPrice)}
                      checked={displayProdPrice}
                    >
                      <p>Display Product Prices</p>
                    </Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <Checkbox
                      onChange={() => setDisplayPayments(!displayPayments)}
                      checked={displayPayments}
                    >
                      <p>Display Payments</p>
                    </Checkbox>
                  </Form.Item>
                </Form>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <Row className='CustomerInformation-div'>

              <Col lg={6} md={24} sm={24} xs={24}>
                <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.customerInfoHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.customerInfoDescription' />
                </p>
              </Col>

              <Col lg={18} md={24} sm={24} xs={24} className='p-0'>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  className=''
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                  <Form.Item>
                    <Checkbox
                      onChange={() =>
                        setDisplayCustomerInfo(!displayCustomerInfo)
                      }
                      checked={displayCustomerInfo}
                    >
                      <p>
                        <IntlMessages id='setup.outletsandregisters.customerInfoLabel' />
                      </p>
                    </Checkbox>
                  </Form.Item>
                  {displayCustomerInfo && (
                    <Form.Item>
                      <Form.Item>
                        <Checkbox
                          checked={getCustomerName}
                          onChange={() => setCustomerName(!getCustomerName)}
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel1' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          checked={getCustomerCompanyName}
                          onChange={() =>
                            setCustomerCompanyName(!getCustomerCompanyName)
                          }
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel2' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          checked={getCustomerCode}
                          onChange={() => setCustomerCode(!getCustomerCode)}
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel3' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          checked={getCustomerEmail}
                          onChange={() => setCustomerEmail(!getCustomerEmail)}
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel4' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          checked={getCustomerPhone}
                          onChange={() => setCustomerPhone(!getCustomerPhone)}
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel5' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          checked={getCustomerAddress}
                          onChange={() =>
                            setCustomerAddress(!getCustomerAddress)
                          }
                        >
                          <p>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel6' />
                          </p>
                        </Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Checkbox
                          onChange={() =>
                            setDisplayLoyaltyBalance(!displayLoyaltyBalance)
                          }
                          checked={displayLoyaltyBalance}
                        >
                          <p className='mb-0'>
                            <IntlMessages id='setup.outletsandregisters.customerInfoLabel7' />
                          </p>
                        </Checkbox>
                        <p className='font-size-smaller'>
                          <IntlMessages id='setup.outletsandregisters.customerInfoSubLabel7' />
                        </p>
                      </Form.Item>

                      {displayLoyaltyBalance && (
                        <InputGroup size='large' className='gx-mb-3'>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right custome-form-col-100 Pro-Note'
                            name='LoyaltyBalance'
                            label={
                              
                                <IntlMessages id='setup.outletsandregisters.customerInfoSubInpLabel7' />
                             
                            }
                          >
                            <Input   maxLength={500}/>
                          </Form.Item>
                        </InputGroup>
                      )}
                    </Form.Item>
                  )}
                </Form>
              </Col>

            </Row>

            <Divider className='mt-3 mb-4' />

            <Row className='Footer-div'>
              <Col lg={6} md={24} sm={24} xs={24}>
                <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id='setup.outletsandregisters.footerHeading' />
                </h2>
                <p className='dk-font-size-15'>
                  <IntlMessages id='setup.outletsandregisters.footerDescription' />
                </p>
              </Col>
              <Col lg={18} md={24} sm={24} xs={24} className='p-0'>
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  className=''
                  scrollToFirstError
                  id='TemplateForm'
                  name='TemplateForm'
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                    name='FooterInformation'
                    label={
                     
                        <IntlMessages id='setup.outletsandregisters.footerInfoLabel' />
                      
                    }
                  >
                    <CKEditor
                      activeClass='p10'
                      content={descriptionFooterContent}
                      events={{
                        change: OnChangeFooterDescription
                      }}
                      config={config}
                    />
                    <p className='font-size-smaller'>
                      <IntlMessages id='setup.outletsandregisters.footercontent' />
                    </p>
                  </Form.Item>

                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={getIsDisplayBarCode}
                        onChange={() =>
                          setIsDisplayBarCode(!getIsDisplayBarCode)
                        }
                      >
                        <p>
                          <IntlMessages id='setup.outletsandregisters.footerCheckboxLabel1' />
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </Form.Item>

                  {/* ////////////////// */}
                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={getIsDisplayOutlet}
                        onChange={() => setIsDisplayOutlet(!getIsDisplayOutlet)}
                      >
                        <p>Display Outlet Name</p>
                      </Checkbox>
                    </Form.Item>
                  </Form.Item>

                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={getIsDisplayRegister}
                        onChange={() =>
                          setIsDisplayRegister(!getIsDisplayRegister)
                        }
                      >
                        <p>Display Register Name</p>
                      </Checkbox>
                    </Form.Item>
                  </Form.Item>

                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={getIsDisplayDateTime}
                        onChange={() =>
                          setIsDisplayDateTime(!getIsDisplayDateTime)
                        }
                      >
                        <p>Display Date and Time</p>
                      </Checkbox>
                    </Form.Item>
                  </Form.Item>

                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={getIsDisplayOnlyPProduc}
                        onChange={() =>
                          setIsDisplayOnlyPProduc(!getIsDisplayOnlyPProduc)
                        }
                      >
                        <p>Display Only Printer's added Products</p>
                      </Checkbox>
                    </Form.Item>
                  </Form.Item>
                  {/* ////////////////// */}

                  <Form.Item>
                    <Form.Item>
                      <Checkbox
                        onChange={() =>
                          setDisplayLoyaltyMessage(!displayLoyaltyMessage)
                        }
                        checked={displayLoyaltyMessage}
                      >
                        <p className='mb-0'>
                          <IntlMessages id='setup.outletsandregisters.footerCheckboxLabel2' />
                        </p>
                      </Checkbox>
                      <p className='font-size-smaller'>
                        <IntlMessages id='setup.outletsandregisters.footerCheckboxSub' />
                      </p>
                    </Form.Item>

                    {displayLoyaltyMessage && (
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right Pro-Note custome-form-col-100'
                        name='LoyaltyMessage'
                        label={
                          
                            <IntlMessages id='setup.outletsandregisters.footerloyaltyMessage' />
                         
                        }
                      >
                        <Input />
                      </Form.Item>
                    )}
                  </Form.Item>
                </Form>
              </Col>
            </Row>

          </div>
        </>
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddReceiptTemplate
